import { render, staticRenderFns } from "./DesignerSearch.vue?vue&type=template&id=0a20b17a"
import script from "./DesignerSearch.vue?vue&type=script&lang=ts"
export * from "./DesignerSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports